module.exports = __webpack_public_path__ + "static/media/31_B.4f133b55.png";